import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Customer } from './Customer';
import { OccupationFactors as GQLOccupationFactors } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class OccupationFactors extends Everything implements GQLOccupationFactors {
  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  liftHeavy50: boolean;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  liftOften25: boolean;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  crouch: boolean;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  repetitiveMotions: boolean;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  extremeClimate: boolean;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  hazards: boolean;

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer) {
    return new OccupationFactors().init(customer);
  }

  init(customer) {
    this.customer = customer;
    return this;
  }
}
